import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../config";

export default function WashBrosSubscribe() {
  const [selected, setSelected] = useState(null); // "lavage" | "abonnement"
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [, setUser] = useState(null);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) return navigate("/login");
    fetch(`${API_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((data) => {
        setUser(data);
        // Plus de redirection automatique : l'utilisateur peut revenir
        // choisir ou changer sa formule même s'il a déjà souscrit
      })
      .catch(() => navigate("/login"));
  }, [navigate, token]);

  const handleSouscrire = async () => {
    if (!selected) return;
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/auth/washbros/souscrire`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ type: selected }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);
      navigate("/paiement", { state: { type: selected } });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 py-12"
      style={{ backgroundColor: "var(--bg)" }}>

      {/* Logo */}
      <img
        src="/images/wash_bros_logo.png"
        alt="Wash Bros"
        className="w-32 h-32 object-contain mb-6 drop-shadow-lg"
      />

      <h1 className="text-3xl font-bold mb-2 text-center" style={{ color: "var(--text)" }}>
        Bienvenue chez Wash Bros
      </h1>
      <p className="text-center mb-10 max-w-md" style={{ color: "var(--text-muted)" }}>
        Le tout premier lavomatic moderne du Togo. Choisissez votre formule et commencez à en profiter dès aujourd'hui.
      </p>

      {/* Cartes choix */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-2xl mb-8">

        {/* Lavage unique */}
        <button
          onClick={() => setSelected("lavage")}
          className={`relative rounded-2xl p-6 text-left border-2 transition-all duration-200 ${
            selected === "lavage"
              ? "border-blue-500 shadow-lg scale-[1.02]"
              : "border-transparent shadow hover:shadow-md hover:scale-[1.01]"
          }`}
          style={{ backgroundColor: "var(--bg-card)" }}
        >
          {selected === "lavage" && (
            <div className="absolute top-4 right-4 w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center text-white text-xs font-bold">✓</div>
          )}
          <div className="text-4xl mb-3">🫧</div>
          <h2 className="text-lg font-bold mb-1" style={{ color: "var(--text)" }}>Lavage Unique</h2>
          <p className="text-sm mb-4" style={{ color: "var(--text-muted)" }}>
            Payez à chaque passage. Idéal pour essayer le service sans engagement.
          </p>
          <ul className="text-sm space-y-1" style={{ color: "var(--text-muted)" }}>
            <li>✅ Accès immédiat</li>
            <li>✅ Carte de fidélité incluse</li>
            <li>✅ Sans engagement</li>
          </ul>
        </button>

        {/* Abonnement mensuel */}
        <button
          onClick={() => setSelected("abonnement")}
          className={`relative rounded-2xl p-6 text-left border-2 transition-all duration-200 ${
            selected === "abonnement"
              ? "border-blue-500 shadow-lg scale-[1.02]"
              : "border-transparent shadow hover:shadow-md hover:scale-[1.01]"
          }`}
          style={{ backgroundColor: "var(--bg-card)" }}
        >
          {/* Badge populaire */}
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full">
            ⭐ Populaire
          </div>
          {selected === "abonnement" && (
            <div className="absolute top-4 right-4 w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center text-white text-xs font-bold">✓</div>
          )}
          <div className="text-4xl mb-3">🎫</div>
          <h2 className="text-lg font-bold mb-1" style={{ color: "var(--text)" }}>Abonnement Mensuel</h2>
          <p className="text-sm mb-4" style={{ color: "var(--text-muted)" }}>
            Accès illimité chaque mois avec des avantages exclusifs pour les abonnés.
          </p>
          <ul className="text-sm space-y-1" style={{ color: "var(--text-muted)" }}>
            <li>✅ Lavages illimités</li>
            <li>✅ Priorité aux machines</li>
            <li>✅ Réductions sur les services</li>
            <li>✅ Carte de fidélité premium</li>
          </ul>
        </button>
      </div>

      {/* Erreur */}
      {error && (
        <p className="text-red-500 text-sm mb-4">{error}</p>
      )}

      {/* Bouton confirmer */}
      <button
        onClick={handleSouscrire}
        disabled={!selected || loading}
        className={`w-full max-w-2xl py-3.5 rounded-xl text-white font-semibold text-base transition-all duration-200 ${
          selected && !loading
            ? "bg-blue-600 hover:bg-blue-700 shadow-md hover:shadow-lg"
            : "bg-gray-300 cursor-not-allowed"
        }`}
      >
        {loading ? "Enregistrement..." : selected ? `Continuer avec ${selected === "lavage" ? "Lavage Unique" : "l'Abonnement Mensuel"}` : "Sélectionnez une formule"}
      </button>

      <p className="text-xs mt-4 text-center" style={{ color: "var(--text-muted)" }}>
        Le paiement sera effectué en boutique lors de votre premier passage.
      </p>
    </div>
  );
}
